let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("iNX42")).then(() => parcelRequire('hB4yo'));